/**
 * Compare Panel
 */

import { addToShortlist } from './shortlist-add-to';

function comparePanel() {
  const c = {
    dom: {
      addToShortlistBtn: 'js-product-heart',
      collection: 'collection',
      compareBtn: 'js-compare-btn',
      comparePanel: 'js-compare-panel-acc',
      comparePanelTab: 'js-acc-btn',
      comparePanelToggle: 'js-compare-panel-toggle',
      productItemApp: 'js-product-item-app',
      shortlistItem: 'js-shortlist-item',
      shortlistItemDetails: 'js-shortlist-item-details',
      shortlistItemImage: 'js-shortlist-item-image',
      shortlistItemMedia: 'js-shortlist-item-media',
      shortlistItemPrice: 'js-shortlist-item-price',
      shortlistItemTitle: 'js-shortlist-item-title',
      shortlistRemaining: 'js-shortlist-remaining',
    },
    cls: {
      active: 'is-active',
      added: 'added',
      empty: 'empty',
      hide: 'hide',
      inactive: 'inactive',
      isSelected: 'is-selected',
    },
  };

  // Globals
  const $comparePanelTab = document.getElementById(c.dom.comparePanelTab);
  const $comparePanel = document.getElementById(c.dom.comparePanel);
  const $shortlistItems = document.querySelectorAll(`.${c.dom.shortlistItem}`);

  // Data
  const sessionStorage = window.sessionStorage || null;
  let view;

  /**
   * Init
   */
  function init() {
    if (!$comparePanel) return;

    addEvents();
    onWindowResize();
    __.windowResize(onWindowResize);
  }

  /**
   * Initialize Compare Panel
   */
  function initComparePanel() {
    const storedShortlistItems = JSON.parse(sessionStorage.getItem('comparePanelStorage'));
    let paddingBottom;

    if (view === 'mobile') {
      paddingBottom = 72;
    } else {
      paddingBottom = 0;
    }

    // Compare Panel accordion
    const comparePanelAccordion = SDG.accordion({
      dom: {
        id: 'js-compare-panel-acc', // id of the accordion
        productItemApp: 'js-product-item-app',
        shortlistItem: 'js-shortlist-item',
        shortlistItemDetails: 'js-shortlist-item-details',
        shortlistItemImage: 'js-shortlist-item-image',
        shortlistItemMedia: 'js-shortlist-item-media',
        shortlistRemaining: 'js-shortlist-remaining',
      },
      cls: {
        hide: 'hide',
      },
      expandDirection: 'up',
      paddingBottom,
    });
    comparePanelAccordion.init();
    const $comparePanelToggle = document.querySelector(`.${c.dom.comparePanelToggle}`);

    if ($shortlistItems && storedShortlistItems && storedShortlistItems.length > 0) {
      storedShortlistItems.forEach((item) => {
        const $emptyShortlistItem = Array.from($shortlistItems).find(
          ($shortlistItem) => $shortlistItem.classList.contains(c.cls.empty),
        );
        addToShortlist(c, item, $emptyShortlistItem);
      });

      __.removeClass($comparePanelTab, c.cls.hide);
      if (!__.hasClass($comparePanelTab, c.cls.active)) {
        $comparePanelTab.click();
      }

      setTimeout(() => {
        $comparePanelToggle.focus();
      }, 10);
    }
  }

  /**
   * Handle Toggle
   * @param {Object} e - click event
   */
  function handleToggle(e) {
    const target = e.target || this;
    const $tabParents = __.parents(target);
    const $tab = $tabParents
      ? $tabParents.find(($parent) => $parent.classList.contains(c.dom.comparePanelTab))
      : null;

    if (!$tab) return;

    toggleTabText($tab);
  }

  /**
   * Toggle Tab Text
   * @param {HTMLElement} $el
   */
  function toggleTabText($el) {
    const $button = $el.querySelector(`.${c.dom.comparePanelToggle}`);
    const $expandText = $button.querySelector('.compare-panel__tab-text--expand');
    const $minimizeText = $button.querySelector('.compare-panel__tab-text--minimize');
    if ($el.classList.contains(c.cls.active)) {
      __.removeClass($expandText, c.cls.hide);
      __.addClass($minimizeText, c.cls.hide);
    } else {
      __.removeClass($minimizeText, c.cls.hide);
      __.addClass($expandText, c.cls.hide);
    }
  }

  /**
   * Add Events
   */
  function addEvents() {
    __.addEvent({
      id: c.dom.comparePanelTab,
      className: c.dom.comparePanelTab,
      event: 'click',
      fn: handleToggle,
    });
  }

  /**
   * On Window Resize
   */
  function onWindowResize() {
    // desktop
    __.mq({
      view: 'desktop',
      callback: () => {
        if (view !== 'desktop') {
          view = 'desktop';
          initComparePanel();
        }
      },
    });

    // mobile
    __.mq({
      view: 'mobile',
      callback: () => {
        if (view !== 'mobile') {
          view = 'mobile';
          initComparePanel();
        }
      },
    });
  }

  return init();
}

export default comparePanel;
